<app-loader [loading]="isLoading" [overlay]="true"></app-loader>
<app-info-message *ngIf="!isLoading && !cartService.isLoading && cartService.isEmpty"
                  [message]="'general.api_cart_empty'" [icon]="'alert'" [large]="true"></app-info-message>
<div *ngIf="modalIsOpened" class="mobile">
  <ng-container *ngTemplateOutlet="cartModals"></ng-container>
  <ng-container *ngTemplateOutlet="cartTotals"></ng-container>
</div>
<div class="content-with-sidebar with-footer" *ngIf="!cartService.isEmpty"
     [ngClass]="{'overlay': modalIsOpened}">
  <div class="content">
    <div class="heading-1" [ngClass]="{'hidden': modalIsOpened}">{{'general.api_cart' | translate}}</div>
    <mat-tab-group class="mobile" *ngIf="!modalIsOpened" mat-align-tabs="left" animationDuration="0ms">
      <mat-tab [label]="'general.api_cart_info' | translate">
        <ng-container *ngIf="cartService.cartType !== CartTypes.SelfService">
          <app-promocode [service]="cartService"></app-promocode>
          <hr class="slim">
        </ng-container>
        <ng-container [ngTemplateOutlet]="cartInfoButtons"></ng-container>
        <ng-container *ngTemplateOutlet="cartTable"></ng-container>
      </mat-tab>
      <mat-tab [label]="'general.api_cart_details' | translate">
        <ng-container [ngTemplateOutlet]="cartDetailActions"></ng-container>
        <ng-container *ngTemplateOutlet="cartTotals"></ng-container>
      </mat-tab>
    </mat-tab-group>
    <div class="desktop"><ng-container [ngTemplateOutlet]="cartInfoButtons"></ng-container></div>
    <mat-card appearance="outlined" class="desktop with-overflow">
      <mat-card-content>
        <ng-container *ngTemplateOutlet="cartTable"></ng-container>
      </mat-card-content>
    </mat-card>
  </div>
  <div class="desktop sidebar">
    <ng-container *ngIf="!modalIsOpened" [ngTemplateOutlet]="cartDetailActions"></ng-container>
    <ng-container *ngIf="modalIsOpened" [ngTemplateOutlet]="cartModals"></ng-container>
    <ng-container *ngTemplateOutlet="cartTotals"></ng-container>
    <ng-container *ngIf="!modalIsOpened" [ngTemplateOutlet]="cartButtons"></ng-container>
  </div>
</div>
<footer class="mobile" *ngIf="showFooter">
  <mat-dialog-actions class="flex flex-column">
    <ng-container [ngTemplateOutlet]="cartButtons"></ng-container>
  </mat-dialog-actions>
</footer>

<ng-template #cartModals>
  <app-cart-modals
    [service]="cartService"
    [modalType]="modalType"
    [paymentType]="paymentType"
    [paymentMethod]="selfServicePaymentMethod"
    [(priceInfo)]="priceInfo"
    [(clientEmail)]="clientEmail"
    [(ticketsPrintedCountBy)]="ticketsPrintedCountBy"
    [backToSale]="backToSale"
    [(ticketType)]="ticketType"
    [disabledButtons]="disabledButtons"
    [(internalComment)]="internalComment"
    (checkoutCart)="checkoutCart()"
    (cancelPayment)="cancelPayment()"
    (proceedTransaction)="proceedTransaction()"
    (confirmPrinting)="confirmPrinting()"
    (scrappingProcess)="scrappingProcess()"
    (retryPrint)="printTransaction(true)"
  ></app-cart-modals>
</ng-template>
<ng-template #cartTable>
  <app-cart-table [service]="cartService"
                  [bulkMode]="bulkMode"
                  (navigateToEventView)="navigateToEventView($event)"
                  (toggleBulkMode)="toggleBulkMode()"
                  [canSelect]="!cartService.isSelfService"
  ></app-cart-table>
</ng-template>
<ng-template #cartTotals>
  <app-cart-totals [cartService]="cartService"></app-cart-totals>
</ng-template>

<ng-template #cartButtons>
  <div class="flex flex-column max-width">
    <ng-container *ngIf="!cartService.isSelfService">
      <ng-container *ngIf="authService.checkPrivileges(Privileges.PAYMENT_OPTIONS)">
        <button mat-flat-button color="primary" *ngIf="cartService.totalSum > 0"
                (click)="openPaymentModal(CARD)" [disabled]="bulkMode || (cartService.hasSelectedSeasonTickets && !cartService.webShopCustomer)">
          {{ 'classifiers.makseliik.name_4' | translate }}
        </button>
        <button mat-stroked-button color="primary" *ngIf="cartService.totalSum > 0"
                (click)="openPaymentModal(CASH)" [disabled]="bulkMode || (cartService.hasSelectedSeasonTickets && !cartService.webShopCustomer)">
          {{ 'classifiers.makseliik.name_1' | translate }}
        </button>
        <button mat-flat-button color="primary" *ngIf="cartService.totalSum <= 0 && cartService.hasSelectedTickets"
                (click)="validateTotalSum()" [disabled]="bulkMode || (cartService.hasSelectedSeasonTickets && !cartService.webShopCustomer)">
          {{ 'general.api_cart_sell_and_print' | translate }}
        </button>
      </ng-container>
      <button mat-flat-button color="primary" *ngIf="authService.user.isPromoter && cartService.hasSelectedTickets"
              (click)="promoterRelease()" [disabled]="bulkMode || (cartService.hasSelectedSeasonTickets && !cartService.webShopCustomer)">
        {{ 'general.api_cart_promoter_release' | translate }}
      </button>
    </ng-container>
    <ng-container *ngIf="cartService.isSelfService">
      <button mat-flat-button color="primary" *ngIf="cartService.totalSum > 0"
              (click)="openSelfServicePaymentModal(PaymentMethodEnum.Card)" [disabled]="bulkMode || disabledButtons">
        {{ 'general.api_cart_self_service_card' | translate }}
      </button>
      <button mat-stroked-button color="primary" *ngIf="cartService.totalSum > 0"
              (click)="openSelfServicePaymentModal(PaymentMethodEnum.Cash)" [disabled]="bulkMode || disabledButtons">
        {{ 'general.api_cart_self_service_cash' | translate }}
      </button>
      <button mat-stroked-button color="primary" *ngIf="centrePropertyService.isEnabled('bo_payment_transfer') && cartService.totalSum > 0"
              (click)="openSelfServicePaymentModal(PaymentMethodEnum.Transfer)" [disabled]="bulkMode || disabledButtons">
        {{ 'general.api_cart_self_service_transfer' | translate }}
      </button>
      <button mat-flat-button color="primary" *ngIf="cartService.totalSum <= 0 && cartService.hasSelectedTickets"
              (click)="openSelfServicePaymentModal()" [disabled]="bulkMode || disabledButtons">
        {{ 'general.api_cart_self_service_no_payment' | translate }}
      </button>
    </ng-container>
  </div>
</ng-template>
<ng-template #cartInfoButtons>
  <div class="flex bottom-spacer space-between">
    <mat-form-field appearance="outline" class="no-hint no-label" *ngIf="cartService.cartType !== CartTypes.SelfService">
      <mat-select [(ngModel)]="cartService.groupTicketsBy" [ngModelOptions]="{standalone: true}">
        <ng-container *ngFor="let groupBy of groupTicketsValues">
          <mat-option *ngIf="!bulkMode || groupBy !== groupTickets.None" [value]="groupBy">
            {{'general.api_cart_group_tickets_by_' + groupBy | translate}}
          </mat-option>
        </ng-container>
      </mat-select>
    </mat-form-field>
    <div class="flex flex-flat" [ngClass]="{'flex-center': !utilService.isMobile}">
      <div class="desktop flex">
        <ng-container *ngIf="!cartService.isSelfService">
          <app-link [icon]="bulkMode ? 'save' : 'bulk_change'" [link]="bulkMode ? 'general.api_cart_bulk_mode_done' : 'general.api_cart_bulk_mode_enter'"
                    (linkClicked)="toggleBulkMode()"></app-link>
          <a class="link" [matMenuTriggerFor]="cartRemoveActionsMenu">
            <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
            <span>{{ 'general.api_cart_remove_tickets' | translate }}</span>
            <mat-icon class="svg-icon icon-dropdown" [svgIcon]="'arrow_down'"></mat-icon>
          </a>
          <mat-menu #cartRemoveActionsMenu="matMenu" [class]="'select-panel select-panel-link'">
            <button mat-menu-item *ngIf="!bulkMode" (click)="cartService.removeTickets()">
              <span>{{ 'general.api_cart_remove_selected' | translate }}</span>
            </button>
            <button mat-menu-item (click)="confirmClear()">
              <span>{{ 'general.api_cart_clear' | translate }}</span>
            </button>
          </mat-menu>
        </ng-container>
        <app-link *ngIf="cartService.isSelfService" [icon]="'trash'" [link]="'general.api_cart_clear'" (linkClicked)="confirmClear()"></app-link>
      </div>
      <div class="mobile flex decreased-margin">
        <ng-container *ngIf="!cartService.isSelfService">
          <button mat-button class="input-button icon-button" (click)="toggleBulkMode()">
            <mat-icon class="svg-icon" [svgIcon]="bulkMode ? 'save' : 'bulk_change'"></mat-icon>
          </button>
          <button mat-button class="input-button icon-button" [matMenuTriggerFor]="cartActions">
            <mat-icon class="svg-icon" [svgIcon]="'menu_vert'"></mat-icon>
          </button>
          <mat-menu #cartActions="matMenu" [xPosition]="'before'">
            <button mat-menu-item *ngIf="!bulkMode" (click)="cartService.removeTickets()">
              <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
              <span>{{ 'general.api_cart_remove_selected' | translate }}</span>
            </button>
            <button mat-menu-item (click)="confirmClear()">
              <mat-icon class="svg-icon" [svgIcon]="'trash'"></mat-icon>
              <span>{{ 'general.api_cart_clear' | translate }}</span>
            </button>
          </mat-menu>
        </ng-container>
        <app-link *ngIf="cartService.isSelfService" [icon]="'trash'" [link]="'general.api_cart_clear'" (linkClicked)="confirmClear()"></app-link>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #cartDetailActions>
  <app-cart-timer></app-cart-timer>
  <mat-card appearance="outlined" class="clean-card" *ngIf="canCreateBooking">
    <div class="heading-3 bold">{{ 'general.api_reservation_make_description' | translate }}</div>
    <button mat-flat-button color="primary" class="three-quarters-width"
            (click)="openBookingModal()" [disabled]="bulkMode || !cartService.hasSelectedTickets">
      {{ 'general.api_reservation_make' | translate }}
    </button>
  </mat-card>
  <app-info-message *ngIf="cartService.isSelfService && zippedTicketsSent"
                    [message]="'general.api_cart_zipped_tickets_sent_in_email'" [messageClass]="'bottom-spacer'"></app-info-message>
  <app-cart-actions [service]="cartService" [bulkMode]="bulkMode"></app-cart-actions>
</ng-template>
